/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext } from 'store/context';
import { Layout } from 'components';
import { Content, Heading, Main, HeaderButton, ButtonContainer, AccessButtonHelperText } from './styles';
import { Col, Row } from 'components/Grid';
import 'react-day-picker/dist/style.css';
import ResponsiveEmbed from 'react-responsive-embed';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalLoaderContext } from 'store/context';

export default function HomePage() {
  const authContext = useContext(GlobalAuthContext);
  const [dashboardQlikUrl, setDashboardQlikUrl] = useState('');
  const loading = useContext(GlobalLoaderContext);

  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const getPersonRootName = function (authContext) {
    if (authContext.login_response &&
      authContext.login_response.ret_value &&
      authContext.login_response.ret_value.rootFirstName &&
      authContext.login_response.ret_value.rootLastName) {
      return (authContext.login_response.ret_value.rootLastName);
    } else {
      return ("**PERSON NAME NOT FOUND**");
    }
  }

  /*
   20201025 - carlos.oliveira
   teste dashboard embeded via microsoft powerbi
   TO-DOs:
   - configurar constante / acesso perfil broker / cliente (domain + função requestAccess)
   - acionar chamada perfil / accesso para determinar perfil broker / cliente
   - ajustar exibição nome pessoa root
   - obter URL endpoint do dashboard embeded via consulta ao backend (params / perfil)
  
   20210117 - carlos.oliveira
   deploy inicial dashboard via powerbi embed - indicador exposure
  */
  const embedDashboardPowerBi = function (authContext) {
    const idPersonTexel = Number(process.env.REACT_APP_FITINSUR_ID_PERSON_TEXEL);
    const dashBaseUrl = String(process.env.REACT_APP_FITINSUR_INTEGRATION_DASHBOARD);
    const dashConfig = String(process.env.REACT_APP_FITINSUR_INTEGRATION_DASHBOARD_CONFIG);
    let dashContentUrl;

    if (authContext.login_response &&
      authContext.login_response.ret_value &&
      authContext.login_response.ret_value.idPersonRoot) {

      let idPersonRoot = authContext.login_response.ret_value.idPersonRoot;
      if (!Boolean(process.env.REACT_APP_FITINSUR_ID_PERSON_PROD)) idPersonRoot = getTempIdPersonRoot(idPersonRoot);
      if (Number(authContext.login_response.ret_value.idPersonRoot) === Number(idPersonTexel)) {
        dashContentUrl = dashBaseUrl + "/?id_person_root=" + idPersonRoot + "&role_name=broker";
      } else {
        dashContentUrl = dashBaseUrl + "/?id_person_root=" + idPersonRoot + "&role_name=client";
      }
      dashContentUrl += "&config_name=" + dashConfig;
    } else {
      dashContentUrl = "about:blank";
    }

    return (
      <Main>
        <Row>
          <Col sm={12} md={12} lg={12} xl={12}>
            <ResponsiveEmbed
              src={dashContentUrl}
              allowfullscreen
              ratio="16:9"
            />
          </Col>
        </Row>
      </Main>
    );
  }

  //------------------------------------------------------------------------------
  //20210119 - temporario - de-para idpersonroot
  /*
  STAGING
  ID_PERSON	PERSON_FIRST_NAME
  5	AIG-Joao
  101703	TEXEL
  126698	23 Capital
  128679	23 Capital
  129791	Aegis
  129792	AIG
  129793	Arch
  129794	Argenta
  129795	Pembroke
  129796	QBE
  139051	BCGE
  139053	CACIB
  139061	Deutsche
  
  DEVELOPER
  ID_PERSON	PERSON_FIRST_NAME
  5	AIG-Joao
  101703	TEXEL
  126698	23 Capital
  128679	23 Capital
  129791	Aegis
  129792	AIG
  129793	Arch
  129794	Argenta
  129795	Pembroke
  129796	QBE
  130104	BCGE
  130106	CACIB
  130114	Deutsche
  
  INTEGRATION
  ID_PERSON	PERSON_FIRST_NAME
  41	23 Capital
  46	ABN Amro
  48	BCGE
  50	CACIB
  58	Commerzbank
  78	Deutsche
  */

  const getTempIdPersonRoot = function (idPersonRoot) {
    let result;
    const idPersonRootListStg = [
      [41, 126698],
      [46, null],
      [48, 139051],
      [50, 139053],
      [58, null],
      [78, 139061]
    ];
    const idPersonRootListDev = [
      [41, 126698],
      [46, null],
      [48, 130104],
      [50, 130106],
      [58, null],
      [78, 130114]
    ];
    // find on staging list
    idPersonRootListStg.find((element) => {
      if (element[1] == idPersonRoot) result = element[0];
    });
    // find on developer list
    if (!result) {
      idPersonRootListDev.find((element) => {
        if (element[1] == idPersonRoot) result = element[0];
      });
    }
    if (!result) result = idPersonRoot;
    return result;
  }

  if (!authContext.status) {
    history.push('login');
  }

  const handleAccessPowerBi = () => {
    const POWERBI_DASHBOARD = process.env.REACT_APP_FITINSUR_INTEGRATION_DASHBOARD;    
    try {
      if(!POWERBI_DASHBOARD || process.env.REACT_APP_USE_POWER_BI_DASHBOARD !== 'true') {
        mc.error('The link to the dashboard is not configured');  
      } else {
        window.open(POWERBI_DASHBOARD, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      mc.error("Occured a problem while opening the dashboard: ", error.message);
    }
  }

  return (
    <>
      <Layout title={'My Dashboard'}>
        <Content>
          <Heading>
            Dashboard - {getPersonRootName(authContext)}
            <ButtonContainer>
              <AccessButtonHelperText>
                Access to the business intelligence complete tool
              </AccessButtonHelperText>
              <HeaderButton onClick={handleAccessPowerBi}>
                ACCESS
              </HeaderButton>
            </ButtonContainer>
          </Heading>
        </Content>

      </Layout>
    </>
  );
}